import { PropertyDataSourceType } from 'src/app/module/order/interface/order.interface';
import { StructureAttribute, UnitAttribute } from 'src/app/module/property/interface/property.interface';

export class PropertyConfig {
  /**
   * All list of sources for property data.
   */
  static readonly propertyDataSourceList: PropertyDataSourceType[] = [
    'userRecord',
    'inspectionRecord',
    'listingRecord',
    'publicRecord',
    'rentalRecord',
    'avmRecord',
  ];

  /** Fields that live at the Structure level within ExtendedPropertyDetail.structures[n] */
  static readonly structureAttributes: ReadonlyArray<StructureAttribute> = [
    'ArchitecturalStyle',
    'Cooling',
    'derivedCooling',
    'derivedHeating',
    'Heating',
    'StructureType',
    'YearBuilt',
    'yearBuiltEstimatedYN',
    'age',
    'foundationWalls',
    'foundationWallsCondition',
    'exteriorWalls',
    'exteriorWallsCondition',
    'Roof',
    'roofCondition',
    'guttersDownspouts',
    'guttersDownspoutsCondition',
    'windows',
    'windowsCondition',
    'stormSash',
    'stormSashCondition',
    'screens',
    'screensCondition',
    'floors',
    'floorsCondition',
    'walls',
    'wallsCondition',
    'trimFinish',
    'trimFinishCondition',
    'bathFloor',
    'bathFloorCondition',
    'bathWainscot',
    'bathWainscotCondition',
    'foundationType',
    'sumpPumpYN',
    'infestationYN',
    'dampnessYN',
    'settlementYN',
    'atticType',
    'HeatingOtherDescription',
    'CoolingOtherDescription',
  ] as const;

  /** Fields that live at the Unit level within ExtendedPropertyDetail.structures[n].units[m] */
  static readonly unitAttributes: ReadonlyArray<UnitAttribute> = [
    'RoomsTotal',
    'BedroomsTotal',
    'BathroomsFull',
    'BathroomsHalf',
    'BathroomsFullCalculated',
    'BathroomsHalfCalculated',
    'BathroomsDecimal',
    'bathroomsTotal',
  ] as const;

  /** Required unit count on the primary structure, derived from PropertySubType. */
  static readonly propertySubTypeUnitCount: Readonly<Record<string, number>> = {
    Duplex: 2,
    Triplex: 3,
    Quadruplex: 4,
    // landOnly: 0, Land Only will be treated like SFR with exception to Validations
    // Multi Family is deliberately absent - its unit count is entered by the user, not derived.
  };

  /** The one PropertySubType whose unit count the user enters instead of it being derived from the sub type. */
  static readonly multifamilySubType: string = 'Multi Family';

  static readonly multifamilyMinUnitCount: number = 1;

  static readonly multifamilyMaxUnitCount: number = 20;

  static getRequiredUnitCount(propertySubType: string | null | undefined): number {
    if (propertySubType == null) {
      return 1;
    }

    return PropertyConfig.propertySubTypeUnitCount[propertySubType] ?? 1;
  }

  static isMultifamilySubType(propertySubType: string | null | undefined): boolean {
    return propertySubType === PropertyConfig.multifamilySubType;
  }
}
